import { FC } from 'react';

import { Envelope } from 'types';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

type EnvelopeDetailsHeaderProps = {
  envelope: Envelope;
};

const EnvelopeDetailsHeader: FC<EnvelopeDetailsHeaderProps> = ({
  envelope,
}) => (
  <PageListHeader
    subTitle={envelope.document.name}
    actions={[<GoBackButton />]}
  />
);

export default EnvelopeDetailsHeader;
